module.exports = __webpack_public_path__ + "img/magenta_one_badge.bf687e63.svg";